import { IOption } from "components/select/Select";
import { IResponse } from "models";

export enum ActionType {
  // get temperature list filter
  GET_TEMPERATURE_LIST_FILTER = "action/GET_TEMPERATURE_LIST_FILTER",
  GET_TEMPERATURE_LIST_FILTER_SUCCESS = "action/GET_TEMPERATURE_LIST_FILTER_SUCCESS",
  GET_TEMPERATURE_LIST_FILTER_ERROR = "action/GET_TEMPERATURE_LIST_FILTER_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IGetTemperatureFilterResponse extends IResponse {
  result: IOption[];
}

export interface TemperatureFilterData {
  locale: string;
}
